import { TableColumn } from '../../components/DataTable/TableColumn';
import { StockHistory } from '../../interfaces/Report/StockHistoryReport/StockHistory';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { partnerPlatformNameMap } from '../../constants/PartnerPlatform';
import { PartnerPlatform } from '../../interfaces/PartnerPlatform/PartnerPlatform';
import { Pagination } from '../../interfaces/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';
import { sharedColors } from '../../utils/Style';

const columns: TableColumn<StockHistory>[] = [
  {
    id: 'created-at',
    name: 'Tarih',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'created-by',
    name: 'Platform',
    accessor: (row) => (
      <TextColumn
        value={
          row.createdBy === 'admin'
            ? 'Admin'
            : partnerPlatformNameMap[row.createdBy as PartnerPlatform] ??
              row.createdBy
        }
      />
    ),
  },
  {
    id: 'old-stock',
    name: 'Önceki Stok',
    accessor: (row) => <TextColumn value={row.oldStock.toString()} />,
  },
  {
    id: 'new-stock',
    name: 'Sonraki Stok',
    accessor: (row) => <TextColumn value={row.newStock.toString()} />,
  },
  {
    id: 'order-id',
    name: 'Sipariş ID',
    accessor: (row) => <TextColumn value={row.orderIdentifier ?? ''} />,
  },
];

type StockHistoryReportTableProps = {
  rows: StockHistory[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const StockHistoryReportTable = ({
  rows,
  totalCount,
  pagination,
  onPagination,
}: StockHistoryReportTableProps) => {
  return (
    <DataTable
      columns={columns}
      totalCount={totalCount}
      rows={rows}
      rowColorizer={(row) =>
        row.operationType === 'reduce'
          ? sharedColors.statusRedLightest
          : sharedColors.statusGreenLightest
      }
      limit={pagination.pageSize}
      setLimit={(newLimit) => onPagination({ page: 0, pageSize: newLimit })}
      page={pagination.page}
      setPage={(newPage) => onPagination({ ...pagination, page: newPage })}
    />
  );
};
